"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplatesGallery = void 0;
var react_1 = __importStar(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var Metadata_1 = require("@CommonFrontend/Metadata/Metadata");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Types_1 = require("@CommonFrontendBackend/Templates/Types");
var GridGallery_1 = __importDefault(require("TemplatesGallery/GridGallery"));
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var lodash_1 = require("lodash");
var ProjectCreatedEvent_1 = require("@CommonFrontendBackend/Telemetry/ProjectCreatedEvent");
var TemplateFilter_1 = require("Common/Templates/TemplateFilter");
var TemplateSortBySelector_1 = require("Common/Templates/TemplateSortBySelector");
var classnames_1 = __importDefault(require("classnames"));
var Telemetry_1 = require("Telemetry");
var TemplatesGalleryTelemetry_1 = __importStar(require("./TemplatesGalleryTelemetry"));
var AccountTemplatesData_1 = require("Dashboard/TemplateManagementDashboard/AccountTemplatesData");
var TemplateList_1 = require("Dashboard/TemplateListItem/TemplateList");
var BetterInfiniteScroll_1 = require("Project/ContentSidebar/Images/BetterInfiniteScroll/BetterInfiniteScroll");
require("TemplatesGallery/TemplatesGallery.ng.html");
exports.default = angular.module("qwilr.templatesGallery", ["ui.router"]).config(function ($stateProvider) {
    $stateProvider.state("templatesGallery", {
        url: "/templates-gallery?onboarding",
        templateUrl: "TemplatesGallery/TemplatesGallery.ng.html",
        controller: function ($scope, createUi, $rootScope, $state) {
            var mountReactComponent = $rootScope.di.child().get("mountReactComponent");
            var telemetry = new TemplatesGalleryTelemetry_1.default($rootScope.di.get("telemetry"));
            var apiBaseUrl = $rootScope.di.get("apiBaseUrl");
            var rolesService = $rootScope.di.get("rolesService");
            var user = $rootScope.di.get("user");
            var pageCreationHelper = $rootScope.di.get("pageCreationHelper");
            var modalService = $rootScope.di.get("modal");
            var rootDataStore = $rootScope.di.get("rootDataStore");
            var userList = $rootScope.di.get("userList");
            var onboarding = $state.params.onboarding;
            $scope.ui = {
                templatesGallery: mountReactComponent(react_1.default.createElement(exports.TemplatesGallery, { telemetry: telemetry, apiBaseUrl: apiBaseUrl, rolesService: rolesService, user: user, state: $state, pageCreationHelper: pageCreationHelper, modalService: modalService, accountIntegrationsDataStore: rootDataStore.getAccountDataStore().getIntegrationsDataStore(), userList: userList, onboarding: onboarding })),
            };
        },
    });
});
var c = (0, BemBuilder_1.default)("templates-gallery-container");
var ALL_CATEGORIES_LABEL = "All categories";
var SEARCH_TERM_DEBOUNCE_MS = 1000;
var MY_TEMPLATES_PAGE_SIZE = 25;
var FEATURED_TEMPLATES_INDEX = 0;
var MY_TEMPLATES_INDEX = 1;
var TemplatesGallery = function (_a) {
    var telemetry = _a.telemetry, state = _a.state, apiBaseUrl = _a.apiBaseUrl, rolesService = _a.rolesService, user = _a.user, accountIntegrationsDataStore = _a.accountIntegrationsDataStore, pageCreationHelper = _a.pageCreationHelper, userList = _a.userList, modalService = _a.modalService, onboarding = _a.onboarding;
    var _b = __read((0, react_1.useState)(onboarding ? FEATURED_TEMPLATES_INDEX : MY_TEMPLATES_INDEX), 2), selectedTabIndex = _b[0], setSelectedTabIndex = _b[1];
    var onSelectedTabIndexChange = function (index) {
        setSelectedTabIndex(index);
        telemetry.tabViewed(index == MY_TEMPLATES_INDEX ? TemplatesGalleryTelemetry_1.TemplateGallerySources.MyTemplates : TemplatesGalleryTelemetry_1.TemplateGallerySources.FeaturedTemplates, selectedTabIndex == MY_TEMPLATES_INDEX
            ? TemplatesGalleryTelemetry_1.TemplateGallerySources.MyTemplates
            : TemplatesGalleryTelemetry_1.TemplateGallerySources.FeaturedTemplates);
    };
    var _c = __read((0, react_1.useState)(null), 2), _template = _c[0], setTemplate = _c[1];
    var onTemplatesChange = function (fn) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            setTemplate(null);
            return fn.apply(void 0, __spreadArray([], __read(args), false));
        };
    };
    var _d = __read((0, react_1.useState)(""), 2), searchTerm = _d[0], setSearchTerm = _d[1];
    var _e = __read((0, react_1.useState)(""), 2), debouncedSearchTerm = _e[0], setDebouncedSearchTerm = _e[1];
    var debouncedSearch = (0, react_1.useCallback)((0, lodash_1.debounce)(setDebouncedSearchTerm, SEARCH_TERM_DEBOUNCE_MS), []);
    var onSearchTermChange = function (searchTerm) {
        setTemplate(null);
        setSearchTerm(searchTerm);
        debouncedSearch(searchTerm);
    };
    var _f = __read((0, react_1.useState)(Types_1.SortField.LastEdited), 2), sortBy = _f[0], setSortBy = _f[1];
    var onSortByChange = onTemplatesChange(setSortBy);
    var _g = __read((0, react_1.useState)(Types_1.SortDirection.Descending), 2), sortDirection = _g[0], setSortDirection = _g[1];
    var onSortDirectionChange = onTemplatesChange(setSortDirection);
    var _h = __read((0, react_1.useState)(new Set()), 2), templatesWith = _h[0], setTemplatesWith = _h[1];
    var onTemplatesWithChange = onTemplatesChange(setTemplatesWith);
    var _j = __read((0, react_1.useState)(new Set()), 2), withCrmInfo = _j[0], setCrmInfo = _j[1];
    var onCrmInfoChange = onTemplatesChange(setCrmInfo);
    var _k = __read((0, react_1.useState)([]), 2), userFilter = _k[0], setUserFilter = _k[1];
    var onUserFilterChange = onTemplatesChange(setUserFilter);
    var _l = __read((0, react_1.useState)(ALL_CATEGORIES_LABEL), 2), selectedCategory = _l[0], setSelectedCategory = _l[1];
    var onSelectedCategoryChange = function (category) {
        telemetry.categoryClicked(category);
        setSelectedCategory(category);
        onSearchTermChange("");
    };
    var myTemplates = (0, AccountTemplatesData_1.useTemplatesInfinite)(apiBaseUrl, {
        pageSize: MY_TEMPLATES_PAGE_SIZE,
        searchTerm: debouncedSearchTerm,
        sortBy: sortBy,
        sortDirection: sortDirection,
        filter: { templatesWith: __spreadArray([], __read(templatesWith), false), withCrmInfo: __spreadArray([], __read(withCrmInfo), false), withUsers: __spreadArray([], __read(userFilter), false) },
        collection: Types_1.TemplateCollection.All,
    }, { shouldFetch: selectedTabIndex === MY_TEMPLATES_INDEX });
    var allMyTemplates = myTemplates.data
        ? myTemplates.data.reduce(function (all, data) {
            return __spreadArray(__spreadArray([], __read(all), false), __read((data.data || [])), false);
        }, [])
        : [];
    var template = _template || allMyTemplates[0];
    (0, react_1.useEffect)(function () {
        telemetry.templateGalleryOpened(onboarding);
        telemetry.tabViewed(selectedTabIndex === MY_TEMPLATES_INDEX
            ? TemplatesGalleryTelemetry_1.TemplateGallerySources.MyTemplates
            : TemplatesGalleryTelemetry_1.TemplateGallerySources.FeaturedTemplates);
    }, []);
    var editTemplate = function (templateId, source) {
        state.go("project", { id: templateId, origin: Telemetry_1.ProjectOpenedOrigin.TemplatesGallery, source: source });
    };
    var previewTemplate = function (template) {
        setTemplate(template);
        telemetry.previewViewed(template._id, TemplatesGalleryTelemetry_1.TemplateGallerySources.TemplateListItem);
    };
    var createPage = function () {
        if (!template) {
            return;
        }
        var templateData = (0, lodash_1.pick)(template, ["name", "crmInfo"]);
        pageCreationHelper.createPageFromTemplate(__assign(__assign({}, templateData), { isAccountTemplate: true, projectId: template._id }), ProjectCreatedEvent_1.ProjectCreationUiOrigin.TemplateGallery);
    };
    var closeAndGoToDashboard = function () {
        telemetry.templateGalleryClosed(onboarding);
        state.go("dashboard", { nav: "pages" });
    };
    return (react_1.default.createElement("div", { className: c() },
        react_1.default.createElement("div", { className: c("nav") },
            react_1.default.createElement("div", { className: c("nav-left") }, onboarding ? (react_1.default.createElement(kaleidoscope_1.Heading, { className: c("heading_onboarding"), strong: true, level: "4" }, "Select a template to get started")) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.Button, { className: c("back-button"), type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Medium, onClick: closeAndGoToDashboard },
                    react_1.default.createElement(icons_1.ArrowLeft, { size: icons_1.IconSize.Medium }),
                    "Back"),
                react_1.default.createElement(kaleidoscope_1.Heading, { className: c("heading"), strong: true, level: "4" }, "Templates")))),
            react_1.default.createElement(kaleidoscope_1.SearchInput, { className: c("search"), label: "", placeholder: "Search templates", value: searchTerm, onChange: onSearchTermChange, onClear: function () { return onSearchTermChange(""); }, onFocus: function () { return selectedCategory != ALL_CATEGORIES_LABEL && setSelectedCategory(ALL_CATEGORIES_LABEL); } }),
            react_1.default.createElement("div", { className: c("nav-right") },
                onboarding && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(kaleidoscope_1.Button, { className: c("create-button"), type: kaleidoscope_1.ButtonType.Primary, size: kaleidoscope_1.ButtonSize.Medium, onClick: closeAndGoToDashboard }, "Go to Dashboard"))),
                !onboarding && selectedTabIndex === MY_TEMPLATES_INDEX && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(kaleidoscope_1.Text, { className: c("page-title"), secondary: true, strong: true, size: "m" }, (template === null || template === void 0 ? void 0 : template.name) || "Untitled"),
                    react_1.default.createElement(kaleidoscope_1.Button, { className: c("create-button"), size: kaleidoscope_1.ButtonSize.Medium, onClick: createPage, disabled: !template }, "Create page"))))),
        react_1.default.createElement("div", { className: c("gallery-container") },
            react_1.default.createElement("div", { className: c("sidebar") },
                react_1.default.createElement("div", { className: c("menubar") },
                    react_1.default.createElement(kaleidoscope_2.Tabs, { initialIndex: selectedTabIndex, onChange: onSelectedTabIndexChange },
                        react_1.default.createElement(kaleidoscope_1.TabList, { className: c("tab-list"), "aria-label": "Template type", isBordered: true },
                            react_1.default.createElement(kaleidoscope_1.Tab, null, "Featured"),
                            react_1.default.createElement(kaleidoscope_1.Tab, null, "My Templates"))),
                    selectedTabIndex === MY_TEMPLATES_INDEX && (react_1.default.createElement("div", { className: c("filter-sort-area") },
                        react_1.default.createElement(TemplateFilter_1.TemplateFilter, { templatesWith: templatesWith, setTemplatesWith: onTemplatesWithChange, accountIntegrationsDataStore: accountIntegrationsDataStore, withCrmInfo: withCrmInfo, setCrmInfo: onCrmInfoChange, userList: userList, userFilter: userFilter, setUserFilter: onUserFilterChange, state: state, hideText: true }),
                        react_1.default.createElement(TemplateSortBySelector_1.TemplateSortBySelector, { sortBy: sortBy, sortDirection: sortDirection, setSortBy: onSortByChange, setSortDirection: onSortDirectionChange, hideText: true })))),
                selectedTabIndex === MY_TEMPLATES_INDEX ? (react_1.default.createElement("div", { className: c("my-templates"), id: "scrollable-templates-container" },
                    react_1.default.createElement(BetterInfiniteScroll_1.BetterInfiniteScroll, { className: c("my-templates-inner-container"), next: function () { return myTemplates.setSize(myTemplates.size + 1); }, hasMore: myTemplates.data && myTemplates.data[myTemplates.data.length - 1].pagination.hasNext, loader: react_1.default.createElement(kaleidoscope_1.Spinner, { className: "space-inset-l" }), dataLength: allMyTemplates.length, scrollableTarget: "scrollable-templates-container" }, allMyTemplates.length === 0 && myTemplates.isLoading ? (react_1.default.createElement(kaleidoscope_1.Spinner, { className: "space-inset-l" })) : (react_1.default.createElement(TemplateList_1.TemplateList, { templates: allMyTemplates, selectedTemplateId: template && template._id, editCallback: editTemplate, previewCallback: previewTemplate, isTemplatesGallery: true, userIsAdmin: rolesService.isAdmin(user), pageSize: MY_TEMPLATES_PAGE_SIZE }))))) : (react_1.default.createElement("div", { className: c("featured-templates") }, Metadata_1.categoryLabels.map(function (category, i) {
                    var _a;
                    return (react_1.default.createElement(kaleidoscope_1.Button, { className: c("category"), type: kaleidoscope_1.ButtonType.Tertiary, width: "full", onClick: function () { return onSelectedCategoryChange(category); }, key: i },
                        react_1.default.createElement("div", { className: (0, classnames_1.default)(c("category-label"), (_a = {},
                                _a[c("category-label", "without-icon")] = category !== ALL_CATEGORIES_LABEL,
                                _a)) },
                            category === ALL_CATEGORIES_LABEL && react_1.default.createElement(icons_1.ListView, { className: c("category-label-icon") }),
                            react_1.default.createElement(kaleidoscope_1.Text, { strong: true }, category),
                            category === selectedCategory && react_1.default.createElement(icons_1.Tick, { className: c("category-label-tick") }))));
                })))),
            selectedTabIndex === MY_TEMPLATES_INDEX ? (react_1.default.createElement("div", { className: c("template-preview-wrapper") }, template ? (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("iframe", { className: c("template-preview"), key: template._id, src: (0, CommonUtils_1.addParamsToUrl)(template.urls.collaboratorUrl, { hideCollaboratorNav: "true" }) }),
                react_1.default.createElement(kaleidoscope_1.Spinner, { className: c("template-preview-spinner") }))) : (react_1.default.createElement("div", { className: c("template-preview-ghost") },
                react_1.default.createElement(kaleidoscope_1.Heading, { className: "title", level: "4", strong: true }, "Templates preview area"),
                react_1.default.createElement(kaleidoscope_1.Text, { className: "subtitle" }, "Preview your templates here"))))) : (react_1.default.createElement("div", { className: c("grid-gallery-wrapper") },
                react_1.default.createElement(GridGallery_1.default, { selectedCategory: selectedCategory, apiBaseUrl: apiBaseUrl, modalService: modalService, searchTerm: debouncedSearchTerm, onboarding: onboarding, pageCreationHelper: pageCreationHelper, telemetry: telemetry }))))));
};
exports.TemplatesGallery = TemplatesGallery;
